import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody49';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy49 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Business Due Diligence </h2>";

  return (
    <>
        <Helmet>
        <title>Business Due Diligence </title>
        <meta property="og:title" content="Business Due Diligence " />
        <meta property='og:description' content='Business Due Diligence '/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy49" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy49
